import "./Contact.module.css";
import Header from "@/reusable_sections/Header";
import LetSDiscussYourMigrationNeeds from "./sections/LetSDiscussYourMigrationNeeds";
import GetInTouch from "./sections/GetInTouch";
import Footer from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <Header />
      <LetSDiscussYourMigrationNeeds />
      <GetInTouch />
      <Footer />
    </div>;
}